import { render, staticRenderFns } from "./SecurityProfileRequest.vue?vue&type=template&id=31a2012a&scoped=true"
import script from "./SecurityProfileRequest.vue?vue&type=script&lang=js"
export * from "./SecurityProfileRequest.vue?vue&type=script&lang=js"
import style0 from "./SecurityProfileRequest.vue?vue&type=style&index=0&id=31a2012a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a2012a",
  null
  
)

export default component.exports